import { render } from "./NeighborhoodView.vue?vue&type=template&id=e04107ea"
import script from "./NeighborhoodView.vue?vue&type=script&lang=js"
export * from "./NeighborhoodView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__